import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { API_ENDPOINT } from '../../index';
import {
    Row,
    Col,
    Button,
    Popconfirm,
    Modal,
    Tag,
    Card
} from 'antd'


class TckCheckerLocationCard extends React.Component {

    constructor(props) {
        super(props);
    }

    

    render(){

        

        return(
            <Row style={{marginTop:"15px"}} >
                <Card 
                    size="small" 
                    style={this.renderCardStyle(this.props.location)}
                    title={
                        <Row type="flex" justify="space-between" align="middle" > 
                            <div>{ `${this.props.location.locationActionRequired} - ${moment(this.props.location.dateScheduled).format("DD/MM/YY")}` } </div>
                            <Button 
                                disabled = { this.props.location.dateCompleted }
                                type={ this.props.selectedLocations.includes(this.props.location._id) ? "primary" : "default" }
                                icon="check" 
                                onClick={(e)=>this.props.onSelectHandler(this.props.location,this.props.location._id,e)} 
                            />
                        </Row>
                    }
                >
                    <Col type="flex" justify="space-between">
                        <Row>
                            {this.props.location.address.name}
                        </Row>
                        <Row>
                            {this.props.location.address.companyName}
                        </Row>
                        <Row>
                            {this.props.location.address.address}
                        </Row>
                        <Row style={{marginTop:"15px"}}> 
                            <Col type="flex" justify="space-between">
                                {
                                    this.props.location.products.map(_product=>
                                        <Row>
                                            { `${_product.productTitle} x${_product.quantity}` }
                                        </Row>
                                    )
                                }
                            </Col>
                        </Row>
                    </Col>
                </Card>
            </Row>
        )
    }

    shouldComponentUpdate(nextProps){

        if(this.props.selectedLocations.includes(this.props.location._id) != nextProps.selectedLocations.includes(nextProps.location._id)){
            return true
        }

        return false
    }


    renderCardStyle = (location) => {
        let style = {
            backgroundColor: `#ffff`
        }
        if(this.props.selectedLocations.includes(location._id)){
            style.backgroundColor =  "#91d5ff"
        }
        if(location.dateCompleted){
            style.backgroundColor =  "#95de64"
        }
        return style
    }

}
export default TckCheckerLocationCard;


// WEBPACK FOOTER //
// ./src/components/delivery-page/TckCheckerLocationCard.js